<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <h3>蕴寓华胤</h3>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 公司简介 -->
      <section id="gsjj">
        <div class="banner-bottom">
          <div class="col-md-1 banner-bottom-left"></div>
          <div class="col-md-4 banner-bottom-left1">
            <div class="banner-bottom-left1-grid">
              <div class="globe">
                <span></span>
              </div>
              <h3><span>We will turn </span>华胤简介</h3>
              <div class="progress progress1">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
              <p>
                华胤是一家外商独资企业，专业从事预制钢结构建筑系统及其相关配件的设计，制造和施工。公司于1994年成立，由一批具有多年美国及澳洲预制钢结构系统经验的专业工程师组成。华胤拥有现代化生产工艺的制造工厂为公司提供5万吨重钢构件及3万吨成型构件的产能。品质管理和焊接制造水平通过美国、欧洲、日本、中国等权威认证，华胤工厂通过美国钢结构协会质量认证（AISC），德国LGA焊接体系认证，通过荷兰DNV、瑞士SGS
                ISO9001质量体系认证，部分产品获得FM全球公司（FM
                Approvals）认证，设计与施工分别获得了中国工程设计甲级证书与中国钢结构制造企业二级资质证书。所有制造流程及质量控制遵照标准作业程序。
                <span class="textShow"
                  >华胤重视每个项目的技术支持及售后服务，在全国分区设立了多个分支机构，保证客户能方便及时地得到华胤的优质服务。大多数著名企业都是华胤的客户，如：金光集团、中国航空货运集团、银鹭集团、六和集团、武汉钢铁集团、顶新集团、扬子石化、Tesco乐购超市、日本川铁、风神汽车、丰田汽车、玖龙纸业、蒙牛乳业、诺基亚移动通讯、菲利浦照明电子、西门子公司、宏基电脑、三星电子、TDK磁带、YKK拉链、巴斯夫石化、日立公司、美的电器、宜家家居等众多国内外知名企业。华胤的工程业绩从食品、电子、造纸、医药到物流、汽车、航空、化工……涵盖各行各业；同时也出口至美国、日本、欧洲、澳州、韩国、泰国、海地甚至南非、安哥拉等非州地区。</span
                >
              </p>
            </div>
          </div>
          <div class="col-md-7 banner-bottom-left2">
            <div class="grid">
              <figure class="effect-lexi effect-lexi1">
                <img src="@/components/img/gyhy/3.jpg" alt="" />
                <figcaption class="lexifig">
                  <p>
                    华胤重视每个项目的技术支持及售后服务，在全国分区设立了多个分支机构，保证客户能方便及时地得到华胤的优质服务。
                  </p>
                </figcaption>
              </figure>
            </div>
            <h3>
              华胤已成功完成了3000多个项目，建筑面积超过1000万平方米，多次荣获“金钢奖”、“工程质量优质奖”等多类奖项。
            </h3>
          </div>
          <div class="clearfix"></div>
        </div>
      </section>

      <!-- 公司文化 -->
      <section id="gswh">
        <div class="banner-bottom1 container">
          <div class="row">
            <div class="col-md-6 banner-bottom-left2 banner-bottom1-left2">
              <div class="grid">
                <figure class="effect-lexi">
                  <img src="@/components/img/gyhy/2.jpg" alt="" />
                  <figcaption>
                    <!-- <h4>华胤集团--<span>企业名称文化</span></h4> -->
                    <p>何为"华胤"?华胤有着自己独特的“胤”文化。</p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="col-md-4 banner-bottom-lft1">
              <h3>01 .</h3>
              <h4>华胤目标</h4>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
              <p>
                华胤集团致力于成为全球钢结构行业的领跑者。我们通过不懈追求技术创新、无与伦比的客户服务和专业的设计敏锐度来实现这一目标。<br>
                我们坚定不移地致力于为客户提供顶级产品，正是通过这种奉献精神，我们的目标是打造世界一流的钢结构品牌。<br>
                我们的目标是超越行业标准，确保我们从事的每个项目都是我们专业知识的灯塔，并且我们坚定不移地致力于在最高水平上追求卓越。 
              </p>
            </div>
            <div class="col-md-2 banner-bottom-left"></div>
            <div class="clearfix"></div>
          </div>
          <div class="row">
            <div class="col-md-2 banner-bottom-left"></div>
            <div class="col-md-4 banner-bottom-lft1">
              <h3>02 .</h3>
              <h4 class="with">华胤愿景</h4>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
              <p>
                我们立志成为全球公认的品牌，以为客户提供不仅可持续而且是卓越代名词的服务而闻名。<br>
                我们将自己视为钢结构行业创新的催化剂、引领革命的灯塔和积极社会影响的驱动力。<br>
                我们的使命是利用我们共同努力的力量，营造一个不仅更强大、更绿色，而且紧密相连的生活环境。我们致力于塑造一个未来，让我们接触到的每一个结构都为子孙后代创造一个更美好的世界。 
              </p>
            </div>
            <div class="col-md-6 banner-bottom-left2 banner-bottom1-left2">
              <div class="grid">
                <figure class="effect-lexi effect-lexi1">
                  <!-- <img
                    v-lazy="gyhy3"
                    alt="Lazy-loaded Image"
                    class="img-responsive"
                  /> -->
                  <img src="@/components/img/gyhy/4.jpg" alt="" />
                  <figcaption class="lexifig">
                    <!-- <h4>华胤集团--<span>企业商标文化</span></h4> -->
                    <p>华胤商标由何而来？华胤商标有着特殊的意义</p>
                  </figcaption>
                </figure>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </section>

      <!--<!~~ 组织架构 ~~>
      <section id="zzjg">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div
                class="banner-bottom-lft1"
                style="background: #fff; text-align: center"
              >
                <h3 class="mobh">03 . 企业组织架构</h3>
                <div class="progress progress1 progress2">
                  <div
                    class="progress-bar progress-bar1"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 40%"
                  >
                    <span class="sr-only">40% Complete</span>
                  </div>
                </div>
              </div>
              <div
                class="banner-bottom-left2 banner-bottom1-left2"
                style="margin-bottom: 10px"
              >
                <div class="grid">
                  <figure class="effect-lexi effect-lexi1">
                    <!~~ <img
                      v-lazy="gyhy4"
                      alt="Lazy-loaded Image"
                      class="img-responsive"
                    /> ~~>
                    <img src="@/components/img/gyhy/5.jpg" alt="" />
                    <figcaption class="lexifig">
                      <!~~ <h4>华胤集团--<span>企业商标文化</span></h4> ~~>
                      <p>华胤集团遍布全球各地，涉及多种行业</p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>-->

      <!-- 公司新闻 -->
      <section id="hyxw">
        <div class="container" style="margin-top: 40px;">
          <div class="row">
            <div
              class="col-md-2 banner-bottom-lft1 visible-xs"
              style="
                background: #fff;
                text-align: center;
                box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
              "
            >
              <h3 class="mobh">03 .<br />华胤<br />新闻</h3>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
            </div>
            <div
              class="col-md-2 banner-bottom-lft1 hidden-xs"
              style="
                background: #fff;
                text-align: center;
                box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
              "
            >
              <h3 class="mobh">03 .<br />华胤<br />新闻</h3>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
            </div>
            <div class="col-md-10">
              <div class="action--site-equipment controller--site">
                <div class="equipmentList">
                  <div class="main">
                    <div class="equipmentListItem">
                      <div
                        class="ListItem ListItems fadeInUp wow animated"
                        data-wow-delay="0.1s"
                        v-for="(item, index) in newsList"
                        :key="index"
                        @click="listClick(index)"
                        :class="{ active: index == showList }"
                      >
                        <div class="Item">
                          <h5>{{ item.newsTitle }}</h5>
                        </div>
                        <div
                          class="Itemtext"
                          :style="{
                            display: index == showList ? 'block' : 'none',
                          }"
                        >
                        <div class="box">
                            <div class="left double-border" >
                              <div class="col-md-4" v-if="item.newsImage!=null">
                                <img :src="item.newsImage" alt="" style="width: 100%;padding: 10px 0;">
                              </div>
                              <div class="col-md-4" v-else>
                                <img src="@/components/img/logoCN.png" alt="" style="width: 100%;padding: 10px 0;">
                              </div>
                              <div class="col-md-8" style="display: flex;align-items: center;justify-content: center;">
                                <p v-html="item.newsContent" style="padding: 15px 0;"></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 公司荣誉 -->
      <section id="gsry">
        <div class="container">
          <div class="row">
            <div
              class="col-md-2 banner-bottom-lft1 visible-xs"
              style="
                background: #fff;
                text-align: center;
                box-shadow: rgba(0, 0, 0, 0.15) -1.6px 4px 3.2px 2.4px;
              "
            >
              <h3 class="mobh">04 .<br />华胤<br />荣誉</h3>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
            </div>
            <div class="col-md-10">
              <div style="text-align: center">
                <h2>资质证书</h2>
              </div>
              <carousel-3d
                :controlsVisible="true"
                :width="cWidth1"
                :height="cHeight1"
                :display="5"
                :space="cSpace1"
              >
                <slide
                  v-lazy-container="{ selector: 'img' }"
                  :index="index"
                  v-for="(item, index) in zzzsList"
                  :key="index"
                >
                  <img :data-src="item.image" class="slideImg" alt="" />
                  <p class="slideP">{{ item.text }}</p>
                </slide>
              </carousel-3d>
              <div style="text-align: center">
                <h2>荣誉证书</h2>
              </div>
              <carousel-3d
                :controlsVisible="true"
                :width="cWidth3"
                :height="cHeight3"
                :display="5"
                :space="cSpace3"
              >
                <slide
                  v-lazy-container="{ selector: 'img' }"
                  :index="index"
                  v-for="(item, index) in ryzsList"
                  :key="index"
                >
                  <img :data-src="item.image" class="slideImg" alt="" />
                  <p class="slideP">{{ item.text }}</p>
                </slide>
              </carousel-3d>
              <div style="text-align: center">
                <h2>专利证书</h2>
              </div>
              <carousel-3d
                :controlsVisible="true"
                :width="cWidth3"
                :height="cHeight3"
                :display="5"
                :space="cSpace3"
              >
                <slide
                  v-lazy-container="{ selector: 'img' }"
                  :index="index"
                  v-for="(item, index) in zlzsList"
                  :key="index"
                >
                  <img :data-src="item.image" class="slideImg" alt="" />
                  <p class="slideP">{{ item.text }}</p>
                </slide>
              </carousel-3d>
            </div>
            <div
              class="col-md-2 banner-bottom-lft1 hidden-xs"
              style="
                background: #fff;
                text-align: center;
                box-shadow: rgba(0, 0, 0, 0.15) -1.6px 4px 3.2px 2.4px;
              "
            >
              <h3 class="mobh">04 .<br />华胤<br />荣誉</h3>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 小滚轮 -->
      <div id="ss_menu">
        <div>
          <i
            ><a @click="forId('gsjj')">华胤<br />简介</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('gswh')">华胤<br />文化</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('hyxw')">华胤<br />新闻</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('gsry')">华胤<br />荣誉</a></i
          >
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      showList: -1,
      zzzsList: [
        {
          image: require('@/components/img/gyhy/zzzs1.png'),
          text: 'CQM环境管理体系认证',
        },
        {
          image: require('@/components/img/gyhy/zzzs2.png'),
          text: 'CQM职业健康安全管理体系认证',
        },
        {
          image: require('@/components/img/gyhy/zzzs3.png'),
          text: 'IQNET认证',
        },
        {
          image: require('@/components/img/gyhy/zzzs4.png'),
          text: 'IQNET认证',
        },
        {
          image: require('@/components/img/gyhy/zzzs5.png'),
          text: '美国钢结构协会质量AISC认证',
        },
        {
          image: require('@/components/img/gyhy/zzzs6.png'),
          text: 'CWB CSA认证',
        },
        {
          image: require('@/components/img/gyhy/zzzs7.png'),
          text: '美国AWS认证',
        },
        {
          image: require('@/components/img/gyhy/zzzs8.png'),
          text: '美国AWS认证',
        },
        {
          image: require('@/components/img/gyhy/zzzs9.png'),
          text: '中国钢结构制造企业资质证书',
        },
        {
          image: require('@/components/img/gyhy/zzzs10.png'),
          text: '欧盟EN1090认证',
        },
        {
          image: require('@/components/img/gyhy/zzzs11.png'),
          text: '欧盟EN ISO3834认证',
        },
        {
          image: require('@/components/img/gyhy/zzzs12.png'),
          text: '瑞士SGS-ISO9001质量体系认证',
        }
      ],
      ryzsList: [
        {
          image: require('@/components/img/gyhy/ryzs1.jpg'),
          text: '中国钢结构十大影响力品牌',
        },
        {
          image: require('@/components/img/gyhy/ryzs2.jpg'),
          text: '重机上海工业有限公司厂房工程',
        },
        {
          image: require('@/components/img/gyhy/ryzs3.jpg'),
          text: '中国货运航空公司物流中心工程',
        },
        {
          image: require('@/components/img/gyhy/ryzs4.jpg'),
          text: '中货航浦东物流中心扩建工程(C型3幢)',
        },
        {
          image: require('@/components/img/gyhy/ryzs5.jpg'),
          text: '中货航浦东物流中心扩建工程(A型7幢)',
        },
        {
          image: require('@/components/img/gyhy/ryzs6.jpg'),
          text: '金刚奖同仁堂',
        },
        {
          image: require('@/components/img/gyhy/ryzs7.jpg'),
          text: '上海赛科',
        },
        {
          image: require('@/components/img/gyhy/ryzs8.jpg'),
          text: '名辰塑料科技有限公司厂房工程',
        },
        {
          image: require('@/components/img/gyhy/ryzs9.jpg'),
          text: '惠生科技园工程',
        },
        {
          image: require('@/components/img/gyhy/ryzs10.jpg'),
          text: '创姿服饰有限公司厂房工程',
        },
        {
          image: require('@/components/img/gyhy/ryzs11.jpg'),
          text: '畅销商品证书',
        },
        {
          image: require('@/components/img/gyhy/ryzs12.jpg'),
          text: '闽江杯奖状',
        },
      ],
      zlzsList: [
        {
          image: require('@/components/img/gyhy/zlzs1.jpg'),
          text: '新型V型拉杆专利证书',
        },
        {
          image: require('@/components/img/gyhy/zlzs2.jpg'),
          text: '新型抗风扣合板专利证书',
        },
        {
          image: require('@/components/img/gyhy/zlzs3.jpg'),
          text: '屋面透气装置专利证书',
        },
        {
          image: require('@/components/img/gyhy/zlzs4.jpg'),
          text: '屋面金属板安装装置专利证书',
        },
        {
          image: require('@/components/img/gyhy/zlzs5.jpg'),
          text: '屋面钢板抗风结构固定座专利证书',
        },
        {
          image: require('@/components/img/gyhy/zlzs6.jpg'),
          text: '手动开门机专利证书',
        },
        {
          image: require('@/components/img/gyhy/zlzs7.jpg'),
          text: '凹凸型压花钢承楼板专利证书',
        },
        {
          image: require('@/components/img/gyhy/zlzs8.jpg'),
          text: '对称双加劲条钢承楼板专利证书',
        },
        {
          image: require('@/components/img/gyhy/zlzs9.jpg'),
          text: '卷帘门抗风装置改进结构专利证书',
        },
        {
          image: require('@/components/img/gyhy/zlzs10.jpg'),
          text: '钢板夹合式屋面专利证书',
        },
      ],
    }
  },
  mounted() {
    // 获取高度
    window.onresize = () => {
      this.changeHeight()
    }

    this.$store.dispatch('newsList')
  },
  computed: {
    // 获取新闻
    ...mapState({
      newsList: (state) => {
        return state.news.newsList
      },
    }),
  },
  methods: {
    // 调用全局方法，滚动指定id
    forId(tId) {
      console.log(tId);
      this.$store.dispatch('toID', tId);
    },

    listClick(index) {
      if (this.showList == index) {
        this.showList = -1
      } else {
        this.showList = index
      }
    },
    //修改轮播图高度
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth1 = 500
        this.cHeight1 = 700
        this.cSpace1 = 400
        this.cWidth2 = 800
        this.cHeight2 = 550
        this.cSpace2 = 400
        this.cWidth3 = 800
        this.cHeight3 = 550
        this.cSpace3 = 350
      } else if (document.body.clientWidth >= 768) {
        this.cWidth1 = 500
        this.cHeight1 = 600
        this.cSpace1 = 320
        this.cWidth2 = 600
        this.cHeight2 = 400
        this.cSpace2 = 380
        this.cWidth3 = 600
        this.cHeight3 = 400
        this.cSpace3 = 250
      } else if (document.body.clientWidth < 768) {
        this.cWidth1 = 400
        this.cHeight1 = 500
        this.cSpace1 = 320
        this.cWidth2 = 600
        this.cHeight2 = 400
        this.cSpace2 = 380
        this.cWidth3 = 600
        this.cHeight3 = 400
        this.cSpace3 = 250
      }
    },
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
  created() {
    this.changeHeight()
  },
}
</script>

<style  scoped>
@import url('./css/global.css');

/* 荣誉图片注释设置 */
.slideImg {
  width: 100%;
  height: 100%;
  margin-bottom: -30px;
  padding-bottom: 30px;
}
.slideP {
  text-align: center;
  color: #000;
  font-size: 16px;
  line-height: 30px;
}
#gsjj {
  margin-top: -83px;
  padding-top: 83px;
}
#gswh {
  margin-top: -83px;
  padding-top: 83px;
}
#zzjg,
#hyxw,
#gsry {
  margin-top: -83px;
  padding-top: 83px;
}
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/gyhy/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  margin-bottom: 5px;
}

/*-- banner-info --*/
.banner-info {
  padding: 14em 0 0;
  text-align: center;
}
.banner-info h3 {
  width: 60%;
  font-size: 4em;
  color: #fff;
  margin: 0 auto;
  line-height: 1.5em;
  padding: 0.5em;
  background: rgba(0, 0, 0, 0.6);
  font-family: 微软雅黑;
}

@media screen and (max-width: 768px) {
  .mobh {
    font-size: 30px !important;
  }
  .banner-bottom-left1-grid p {
    margin: 1em 0 !important;
    font-size: 13px !important;
  }
}
/*-- banner-bottom --*/
.banner-bottom-left p {
  color: #fff;
  font-size: 14px;
  margin: 0;
  line-height: 1.8em;
}
.banner-bottom-left1 {
  padding: 8em 5em 5em;
  background: #a56c41;
}
.banner-bottom-left2 {
  padding: 0;
}
.globe span {
  background: url(@/components/img/gyhy/img-sp.png) no-repeat 22px -81px;
  display: block;
  width: 128px;
  height: 128px;
  border: 1px solid #3f647d;
  border-radius: 100%;
}
.banner-bottom-left1-grid h3 {
  margin: 1.5em 0 0;
  color: #fff;
  font-size: 4em;
  text-transform: capitalize;
}
.banner-bottom-left1-grid h3 span {
  font-size: 0.3em;
  display: block;
  margin-bottom: 1em;
}
.progress1 {
  height: 2px;
  margin-bottom: 0;
  border-radius: 0;
  margin: 1.5em 0 0;
}
.progress-bar1 {
  background: #eb6f63;
}
.banner-bottom-left1-grid p {
  margin: 2em 0 2em;
  color: #fff;
  font-size: calc(100vw * 16 / 1644);
  line-height: 1.8em;
}
.banner-bottom-left2 h3 {
  padding: 2.5em 3em 0;
  font-size: calc(100vw* 28 / 1644);
  color: #212121;
  margin: 0;
  line-height: 1.6em;
  position: relative;
  font-family: 'Open Sans', sans-serif;
}

/*-- effect --*/
.grid {
  position: relative;
  clear: both;
  margin: 0 auto;
  max-width: 1000px;
  list-style: none;
  text-align: center;
}

/* Common style */
.grid figure {
  position: relative;
  float: none;
  overflow: hidden;
  margin: 0;
  min-width: 273px;
  max-width: 100%;
  max-height: auto;
  width: 100%;
  height: auto;
  background: #3085a3;
  text-align: center;
}

.grid figure img {
  position: relative;
  display: block;
  min-height: 100%;
  max-width: 100%;
  opacity: 0.8;
}

.grid figure figcaption {
  padding: 2em;
  color: #fff;
  text-transform: uppercase;
  font-size: 1.25em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.grid figure figcaption::before,
.grid figure figcaption::after {
  pointer-events: none;
}

.grid figure figcaption,
.grid figure figcaption > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
/***** Lexi *****/
/*---------------*/

figure.effect-lexi {
  background: -webkit-linear-gradient(-45deg, #000 0%, #fff 100%);
  background: linear-gradient(-45deg, #000 0%, #fff 100%);
}

figure.effect-lexi img {
  margin: -10px 0 0 -10px;
  max-width: none;
  width: -webkit-calc(100% + 10px);
  width: calc(100% + 10px);
  opacity: 0.9;
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  -webkit-transform: translate3d(10px, 10px, 0);
  transform: translate3d(10px, 10px, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

figure.effect-lexi figcaption::before,
figure.effect-lexi p {
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
}

figure.effect-lexi figcaption::before {
  position: absolute;
  left: -40px;
  bottom: -60px;
  width: 330px;
  height: 330px;
  border: 2px solid #fff;
  border-radius: 50%;
  box-shadow: 0 0 0 900px rgba(255, 255, 255, 0.2);
  content: '';
  opacity: 0;
  -webkit-transform: scale3d(0.5, 0.5, 1);
  transform: scale3d(0.5, 0.5, 1);
  -webkit-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
}
figure.effect-lexi figcaption.lexifig::before {
  right: -40px;
  left: auto;
}

figure.effect-lexi:hover img {
  opacity: 0.6;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

figure.effect-lexi h4 {
  font-size: 1.5em;
  text-transform: capitalize;
  text-align: left;
  padding: 0.5em 1em;
  background: rgba(200, 0, 0, 0.4);
  width: 66%;
  text-align: left;
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(5px, 5px, 0);
  transform: translate3d(5px, 5px, 0);
}

figure.effect-lexi h4 span {
  color: #000;
}

figure.effect-lexi p {
  position: absolute;
  left: 0;
  bottom: 2%;
  padding: 0 0 1.5em 1em;
  width: 250px;
  text-align: left;
  opacity: 0;
  -webkit-transform: translate3d(20px, 20px, 0);
  transform: translate3d(20px, 20px, 0);
  font-size: 0.8em;
  line-height: 1.8em;
}

figure.effect-lexi1 p {
  right: 0;
  padding: 0 1em 1.5em 0 !important;
  left: auto;
}

figure.effect-lexi:hover figcaption::before {
  opacity: 1;
  -webkit-transform: scale3d(1, 1, 1);
  transform: scale3d(1, 1, 1);
}

figure.effect-lexi:hover h4,
figure.effect-lexi:hover p {
  opacity: 1;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}
/*-- //effect --*/
/*-- //banner-bottom --*/
/*-- banner-bottom1 --*/
.banner-bottom-lft1 h3 {
  font-size: 5em;
  color: #3f5a6d;
  margin: 0;
}
.banner-bottom-left1,
.banner-bottom-lft1 {
  padding: 2.17em 4em 4em;
  background: #a56c41;
}
.banner-bottom-lft1 h4 {
  font-size: 3em;
  color: #fff;
  text-align: right;
  margin: 1em 0 0em;
  line-height: 1.5em;
  font-family: 'Open Sans', sans-serif;
}
.progress2 {
  margin: 1em 0 0;
}
.banner-bottom-lft1 p {
  margin: 2.5em 0 0;
  color: #fff;
  font-size: calc(100vw * 16 / 1644);
  line-height: 1.8em;
}
h4.with {
  text-align: left;
}

/*-----start-responsive-design------*/
@media (max-width: 1680px) {
  .banner-bottom-left1,
  .banner-bottom-lft1 {
    padding: 2.17em 4em 3em;
  }
  .progress2 {
    margin: 1.6em 0 0;
  }
  .banner-bottom-left2 h3 {
    padding: 1.5em 3em 0;
  }
}
@media (max-width: 1600px) {
  .banner-bottom-left1,
  .banner-bottom-lft1 {
    padding: 2.17em 4em 4em;
  }
  .progress2 {
    margin: 1em 0 0;
  }
  .banner-bottom-left2 h3 {
    padding: 2.5em 3em 0;
  }
}
@media (max-width: 1440px) {
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -90px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 3.7em;
  }
  .banner-bottom-lft1 {
    padding: 1em 2em 2.04em;
  }
  figure.effect-lexi h4 {
    width: 75%;
  }
}
@media (max-width: 1366px) {
  .banner-info {
    padding: 10em 0 0;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -50px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 3.4em;
  }
  .banner-bottom-left2 h3 {
    font-size: calc(100vw* 28 / 1644);
  }
  .banner-bottom-left1 {
    padding: 2em 3em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 1.7em;
  }
  .banner-bottom-lft1 h3 {
    font-size: 4em;
  }
  figure.effect-lexi h4 {
    width: 79%;
  }
}
@media (max-width: 1280px) {
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -90px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-lft1 h4 {
    font-size: 1.5em;
  }
  .banner-bottom-lft1 {
    padding: 1em 2em 1.3em;
  }
  figure.effect-lexi h4 {
    font-size: 1.3em;
  }
  .banner-bottom-left1-grid h3 {
    margin: 1em 0 0;
  }
  .banner-bottom-lft1 p {
    margin: 2.4em 0 0;
  }
}
@media (max-width: 1080px) {
  .banner-info h3 {
    font-size: 2em;
  }
  .banner-info {
    padding: 8em 0 0;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -125px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }

  .banner-bottom-left1-grid h3 {
    font-size: 2.5em;
  }
  .banner-bottom-left2 h3 {
    padding: 2.5em 4em 0;
    font-size: 1.5em;
  }
  figure.effect-lexi figcaption::before {
    width: 260px;
    height: 260px;
  }
  figure.effect-lexi p {
    bottom: -3%;
    width: 155px;
    font-size: 13px;
  }
  .banner-bottom-left1 {
    padding: 2em 2em 5em;
  }
  .banner-bottom-left1-grid p {
    margin: 2em 0 3em;
  }
  .m1 a {
    padding: 6px 175px 10px !important;
  }
  .banner-bottom-lft1 h4 {
    font-size: 1.3em;
  }
  .banner-bottom-lft1 h3 {
    font-size: 3em;
  }
  .banner-bottom-lft1 p {
    margin: 1em 0 0;
  }
  .banner-bottom-left {
    width: 6%;
  }
  .banner-bottom-left2 {
    width: 68.33%;
  }
  .banner-bottom1-left2 {
    width: 58.33% !important;
  }
  .banner-bottom-lft1 {
    padding: 1em 2em 4.4em;
    width: 35.66%;
  }
  .banner-bottom-slider-left h3 span {
    font-size: 1.5em;
  }
  figure.effect-lexi h4 {
    width: 80%;
  }
  .banner-bottom-slider-right {
    padding: 0;
  }
  .banner-bottom-slider-right1 ul li a {
    font-size: 14px;
  }
  .banner-bottom-slider-right1 p span {
    font-size: 1.14em;
  }

  .blog-title {
    padding: 1.5em 0.5em;
  }
  .blod-meta li::before {
    margin: 0 1px;
  }
  .blod-meta {
    padding: 0 0 10px;
    margin: 1em 0 0em;
  }
  .blog-title p {
    font-size: 12px;
  }
  .panel-title {
    font-size: 1.1em;
    background: url(@/components/img/gyhy/1.png) no-repeat 242px -2px;
  }
  .panel-title1 {
    background: url(@/components/img/gyhy/1.png) no-repeat 0 1px !important;
  }
  .panel-default:nth-child(2) {
    margin: 1em 0 !important;
  }
  .comments ul li {
    margin-right: 1em;
  }
  .single-left h3 {
    font-size: 1.2em;
  }
  .single-left h3:before {
    height: 100%;
  }
  .single-left3-grid p {
    font-size: 14px;
  }
  .leave-a-comment input[type='text'],
  .leave-a-comment input[type='email'],
  .leave-a-comment textarea {
    width: 32.04%;
  }
  .leave-a-comment h3 {
    margin: 0 0 1em;
  }

  .mail input[type='text'],
  .mail input[type='email'],
  .mail textarea {
    width: 49.3%;
  }
  .mail input[type='submit'] {
    margin-left: 29.8em;
  }
}
@media (max-width: 1024px) {
  .banner-bottom-left1 {
    padding: 2em 2em 2em;
  }
  .banner-bottom-lft1 {
    padding: 1em 2em 1.5em;
  }
}
@media (max-width: 991px) {
  .p-mask h4 {
    font-size: 1em;
    line-height: 1.5em;
  }
  .p-mask p {
    line-height: 1.5em;
    font-size: 13px;
  }

  .banner-info h3 {
    width: 70%;
  }

  .banner {
    background: url(@/components/img/gyhy/1.jpg) -163px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .social-icons {
    padding: 5em 0 0;
  }
  .banner-bottom-left1 {
    float: none;
    width: 70%;
    margin: 0 auto;
    padding: 3em 3em 4em;
  }
  .banner-bottom-left2 {
    float: none;
    margin: 0 auto;
    width: 70%;
  }
  .banner-bottom-left2 h3 {
    padding: 2em 3em 2em;
  }
  .banner-bottom1-left2 {
    width: 70% !important;
  }
  .banner-bottom-lft1 {
    padding: 1em 3em 3em;
    float: none;
    width: 70%;
    margin: 0 auto 2em;
  }
  .banner-bottom-lft1:nth-child(6) {
    margin: 0 auto;
  }
  .banner-bottom-slider-left {
    margin: 0 0 2em;
  }
  .banner-bottom-slider-right1 p span {
    font-size: 1.5em;
  }

  .testimonials-grid {
    float: left;
    width: 33.33%;
  }
  .history-right {
    margin: 2em 0 0;
  }
  figure.blog-figure img {
    width: 100%;
  }
  .panel-group .panel {
    text-align: left;
  }
  .panel-title1 {
    background: url(@/components/img/gyhy/1.png) no-repeat 0 -3px !important;
  }

  .search1 input[type='submit'] {
    margin: 1em 0 0;
  }
  .categories {
    margin: 3em 0;
  }
  .categories-mid ul li:nth-child(6) {
    margin-bottom: 0;
  }
  .single-left {
    margin: 3em 0 0;
  }
  .single-left1-grid:nth-child(2) {
    margin: 2em 0;
  }
  .single-left2 {
    margin: 0 0 2em;
  }
  .single-left3-grid {
    float: left;
    width: 50%;
  }
  .leave-a-comment input[type='text'],
  .leave-a-comment input[type='email'],
  .leave-a-comment textarea {
    width: 31.65%;
  }
  .mail input[type='submit'] {
    margin-left: 34.6em;
  }
  .contact-right1-pos {
    left: 3.5%;
    width: 55%;
    min-height: 90%;
  }
}
@media (max-width: 800px) {
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -217px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1,
  .banner-bottom-left2,
  .banner-bottom-lft1 {
    width: 90% !important;
  }
}
@media (max-width: 768px) {
  .testimonials-grid2 {
    padding: 1em;
  }
  .testimonials-grid1 h4 {
    font-size: 1.1em;
  }
  .single-left1 h5 {
    margin: 0 0 1em;
  }
}
@media (max-width: 667px) {
  .banner-info h3 {
    font-size: 1.8em;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -250px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
}
@media (max-width: 640px) {
  .p-mask h4 {
    font-size: 1.5em;
    line-height: 1.8em;
  }

  .progress1 {
    height: 2px !important;
    margin-bottom: 0 !important;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 2em;
  }
  .m1 a {
    padding: 0px 110px 10px !important;
  }
  .banner-bottom-left2 h3 {
    padding: 2em 2em 2em;
  }

  figure.effect-lexi h4 {
    width: 85%;
  }

  p.dummy-text {
    padding-left: 15em;
  }
  .testimonials-grid1 h4 {
    font-size: 1.4em;
  }
  .testimonials-grid {
    padding-left: 0;
  }

  .single-left1-grid p span {
    display: inline;
    margin: 0;
  }
  .single-left2 {
    margin: 0;
  }
  .comments-admin h4,
  .leave-a-comment h3 {
    font-size: 1.7em;
  }
  .leave-a-comment input[type='text'],
  .leave-a-comment input[type='email'],
  .leave-a-comment textarea {
    width: 31.29%;
  }
  .leave-a-comment input[type='submit'] {
    font-size: 14px;
    width: 35%;
  }
  .mail {
    margin: 2em 0 0;
  }
  .mail input[type='text'],
  .mail input[type='email'],
  .mail textarea {
    width: 49.26%;
  }
  .mail input[type='submit'] {
    margin-left: 28em;
  }
  .contact-right1-pos {
    left: 3.5%;
    width: 69%;
    min-height: 92%;
    top: 4%;
  }
}
@media (max-width: 600px) {
  .banner-info h3 {
    font-size: 1.5em;
  }
}
@media (max-width: 568px) {
  .banner-info {
    padding: 5em 0 0;
  }
}
@media (max-width: 480px) {
  .banner-info {
    padding: 6em 0 0;
  }
  .banner-info h3 {
    font-size: 1.3em;
    width: 80%;
  }

  .social-icons {
    padding: 4em 0 0;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -267px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1,
  .banner-bottom-left2,
  .banner-bottom-lft1 {
    width: 95% !important;
  }
  figure.effect-lexi h4 {
    font-size: 1em;
  }
  .grid figure figcaption {
    padding: 1em;
  }
  .banner-bottom-left2 h3 {
    font-size: 13px;
  }
  .banner-bottom-lft1 h4 {
    font-size: 1.2em;
  }
  .banner-bottom-lft1 {
    padding: 1em 2em 2em;
  }
  .banner-bottom-lft1 {
    margin: 0 auto 0.8em;
  }

  .comments ul li {
    margin-bottom: 1em;
  }
  .single-left {
    padding-left: 1em;
    padding-right: 0;
  }
  .leave-a-comment input[type='text'],
  .leave-a-comment input[type='email'],
  .leave-a-comment textarea {
    width: 100%;
  }
  .leave-a-comment input[type='email'] {
    margin: 1em 0;
  }
  .leave-a-comment textarea {
    min-height: 150px;
    margin: 1em 0 0.8em;
  }
  .leave-a-comment input[type='submit'] {
    width: 100%;
    padding: 8px 0;
  }
  .contact-left1 iframe {
    min-height: 200px;
  }
  .contact-left2 h4 {
    margin: 1em 0 1em;
  }
  .mail input[type='text'],
  .mail input[type='email'],
  .mail textarea {
    width: 100%;
  }
  .mail input[type='email'] {
    margin: 0.5em 0 0;
  }
  .mail input[type='submit'] {
    margin: 0 0 2em;
  }
  .mail input[type='submit'] {
    width: 100%;
    padding: 8px 0;
  }
  .contact-right p {
    margin: 1em 0 0 1em;
  }
  .contact-right1-pos {
    left: 5.5%;
    width: 89%;
    min-height: 91%;
    top: 4.5%;
  }
}
@media (max-width: 414px) {
  .banner-info h3 {
    font-size: 2em;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
    height: 190px !important;
  }
  .banner-bottom-left1 {
    padding: 2em 2em 3em;
  }
  .globe span {
    background: url(@/components/img/gyhy/img-sp.png) no-repeat 16px -55px;
    background-size: 400%;
    width: 90px;
    height: 90px;
  }
  figure.effect-lexi p {
    width: 145px;
    font-size: 10px;
  }
  figure.effect-lexi figcaption::before {
    width: 210px;
    height: 210px;
  }
  .banner-bottom-slider-left h3 span {
    font-size: 1.2em;
  }
  .banner-bottom-slider-left {
    margin: 0 0 1.5em;
  }
  .testimonials-grid {
    width: 100%;
  }
  .single-right {
    padding: 0;
  }
  .single-left3-grid {
    float: none;
    width: 100%;
  }
  .single-left3-grid:nth-child(1) {
    margin-bottom: 1em;
  }
  .admin {
    margin: 2em 0;
    padding: 1em;
  }
  .comments-admin-grids {
    margin: 2em 0 0;
  }
  .comments-admin h4,
  .leave-a-comment h3 {
    font-size: 1.5em;
  }
  .leave-a-comment {
    margin: 3em 0 0;
  }
  .contact-left,
  .contact-right {
    padding: 0;
  }
}
@media (max-width: 384px) {
  .banner-info h3 {
    width: 90%;
  }
  .social-icons {
    padding: 3em 0 0;
  }
}

@media (max-width: 768px) {
  .banner-info h3 {
    font-size: 1.5em;
    width: 100%;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -252px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-info {
    padding: 4em 0 0;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 1.5em;
  }
  .progress1 {
    margin: 1em 0 0;
  }
  .banner-bottom-left1-grid p {
    margin: 1em 0 2em;
    font-size: 13px;
  }
  .banner-bottom-left1 {
    padding: 1em 1em 2em;
  }
  .m1 a {
    padding: 0px 80px 10px !important;
  }
  .grid figure figcaption {
    padding: 0em 1em;
  }
  .banner-bottom-left2 h3 {
    font-size: 1em;
    line-height: 1.8em;
  }
  .banner-bottom-lft1 {
    padding: 1em 1em 2em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 1.5em;
  }
  .banner-bottom-lft1 p {
    font-size: 13px;
  }

  figure.effect-lexi h4 {
    width: 91%;
  }
  .equipmentList .equipmentListItem .ListItem .Item h5 {
    font-size: 18px;
  }
}
/* 小滚轮 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #a56c41;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 12px;
  text-align: center;
  background: #a56c41;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #ed9048;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -160px;
}

#ss_menu div:nth-child(2) {
  top: -80px;
  left: -138.56406px;
}

#ss_menu div:nth-child(3) {
  top: -138.56406px;
  left: -80px;
}

#ss_menu div:nth-child(4) {
  top: -160px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
@media screen and (max-width: 1999px) {
  .textShow {
    display: none;
  }
}
@media screen and (min-width: 2000px) {
  .banner-bottom-left1-grid p {
    font-size: 20px;
  }
  .textShow {
    display: block;
  }
  .grid {
    max-width: 1500px;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 5em;
  }
  .banner-bottom-lft1 h3 {
    font-size: 6em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 4em;
  }
  .banner-bottom-lft1 p {
    font-size: 20px;
  }
  .equipmentList .equipmentListItem .ListItem .Item h5 {
    font-size: 25px;
  }
  .equipmentList .equipmentListItem .ListItem .Itemtext .box .left p {
    font-size: 20px;
    line-height: 30px;
  }
  .slideP {
    font-size: 20px;
  }
}
.double-border {
  width: 100% !important;
  position: relative;
  border: 2px solid #000;
  padding: 5px;
}
/* 外边框样式 */
.double-border::before {
  content: "";
    position: absolute;
    width: 40px;
    height: 40px;
    transition: .3s ease-in-out;
    top: -8px;
    left: -8px;
    border-top: 2px solid #000;
    border-left: 2px solid #000;
}
.double-border::after {
    content: "";
    position: absolute;
    width: 40px;
    height: 40px;
    transition: .3s ease-in-out;
    right: -8px;
    bottom: -8px;
    border-bottom: 2px solid #000;
    border-right: 2px solid #000;
  
}
</style>
